export default __webpack_public_path__ + "static/media/warning_icon_white_bordered.1aa1e7c0.svg";